<template>
  <div class="ov">
    <CoolLightBox
      :items="items"
      :index="index"
      @close="index = null">
    </CoolLightBox>
    <ul class="items fang">
      <li v-for="(image, imageIndex) in product">
        <a @click="index = imageIndex"><v-lazy-image :src="image.small_pic" :alt="image.title" /></a>
      </li>
    </ul>
  </div>
</template>

<script>
import finder from '../mock/finder.json'
import VLazyImage from "v-lazy-image/v2";

export default {
  name: 'zuopin',
  components: {
    VLazyImage
  },
  data () {
    return {
      finder,
      items: [],
      index: null
    }
  },
  computed: {
    product () {
      let product = this.finder.finder_product.filter(item => item.categoryid === '1').reverse() || []
      for (let i = 1; i <= 94; i++) {
        if (i === 8 ) continue
        product.unshift({
          "id": 500 + i,
          "categoryid": "1",
          "title": "",
          "small_pic": "http://xusihai.artui.com/"+i+".jpg:thumb",
          "big_pic": "http://xusihai.artui.com/"+i+".jpg:large",
          "productdate": null,
          "addtime": "2022-02-29 20:07:43",
          "default": "0",
          "orderid": 500 + i
        })
      }
      let l = []
      product.map(item => {
        l.push({
          title: item.title,
          src: item.big_pic
        })
      })
      this.items = l
      return product
    }
  }
}
</script>
